import { Select } from 'antd';
import styled from 'styled-components';
import { BasicTable } from '../../../../../../assets/common';

export const CriteriaCustomTable = styled(BasicTable)`
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.3px;
  color: #3f3c4c;

  .ant-table-tbody > tr > td {
    vertical-align: top;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .ant-table-thead > tr > th:first-child,
  .ant-table-tbody > tr > td:first-child {
    padding-left: 80px;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: #fff;
  }
`;

export const CustomSelect = styled(Select)`
  font-weight: 400;
  text-align: left;

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    color: #8d8d8d !important;
  }
`;
